import { Injectable } from '@angular/core';
import { AppConfig } from '../../app/app.config';
import { HttpClient } from '@angular/common/http';
import { DateService } from '../date/date.service';
import { DateParserService } from '../daily-log/daily-log-time/date-parser-service';
import { TimeZoneService } from '../time-zone/time-zone.service';
import { DateTime } from 'luxon';
import { WeatherLogStandaloneEditor } from '../../models/weather-readings/weather-readings.models';

@Injectable()
export class WeatherLogAdditionalReadingService {

  config = AppConfig.settings;

  constructor(
    private http: HttpClient,
    private dateService: DateService,
    private dateParserService: DateParserService,
    private timeZoneService: TimeZoneService
  ) {
  }

  async saveWeatherLogAdditionalReadingEditor(editor: WeatherLogStandaloneEditor): Promise<number> {
    editor = this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/weatherreading/standalone/save`;

    return this.http
      .post<number>(url, editor)
      .toPromise()
      .then((res: number) => {
        return res;
      });
  }

  async validateTime(editor: WeatherLogStandaloneEditor): Promise<boolean> {
    editor = this.dateParserService.removeOffsetFromLuxonDates(editor);

    const url = `${this.config.apiUrl}api/weatherreading/standalone/validate`;

    return this.http
      .post<boolean>(url, editor)
      .toPromise()
      .then((res: boolean) => {
        return res;
      });
  }

  async deleteWeatherLogStandaloneEditor(editor: WeatherLogStandaloneEditor): Promise<void> {
    const url = `${this.config.apiUrl}api/weatherreading/standalone/delete`;

    await this.http.post<void>(url, editor).toPromise();
  }

  async getGridData(dailyLogDate: DateTime, projectId: number): Promise<WeatherLogStandaloneEditor[]> {
    const dateLong = dailyLogDate.toMillis();
    const url = `${this.config.apiUrl}api/weatherreading/standalone/${dateLong}/${projectId}`;

    let result = await this.http.get<WeatherLogStandaloneEditor[]>(url).toPromise();

    result = await this.setStandaloneReadingEditorLocalDates(result);

    return result;
  }

  private async setStandaloneReadingEditorLocalDates(editors: WeatherLogStandaloneEditor[]): Promise<WeatherLogStandaloneEditor[]> {
    for (let i = 0; i < editors.length; i++) {
      editors[i].readingTime = await this.dateParserService.deserializePtLuxonDate(editors[i].readingTime, this.timeZoneService, editors[i].readingTimeOffset);

      if (editors[i].readingTime) {
        editors[i].readingTimeShow = this.dateService.setFullTimeString(editors[i].readingTime.dateTime);
      }
    }

    return editors;
  }
}



// WEBPACK FOOTER //
// ./src/services/weather-readings/weather-log-additional-reading.service.ts